import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

const getToken = (user) => user.getIdToken();

export const apiPost = async (path, user, body = {}) => {
  const token = await getToken(user);
  return axios.post(`${API_BASE}${path}`, body, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const apiGet = async (path, user) => {
  const token = await getToken(user);
  return axios.get(`${API_BASE}${path}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const apiDelete = async (path, user) => {
  const token = await getToken(user);
  return axios.delete(`${API_BASE}${path}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const apiPatch = async (path, user, body = {}) => {
  const token = await getToken(user);
  return axios.patch(`${API_BASE}${path}`, body, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const apiGetBlob = async (path, user) => {
  const token = await getToken(user);
  return axios.get(`${API_BASE}${path}`, {
    headers: { Authorization: `Bearer ${token}` },
    responseType: 'blob',
  });
};

export const apiPostFile = async (path, user, formData) => {
  const token = await getToken(user);
  return axios.post(`${API_BASE}${path}`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    },
  });
};
